import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { WalletIcon, getWalletBookWallet } from '@dynamic-labs/wallet-book';
import '@dynamic-labs/iconic';
import '../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgStroke } from '../../../shared/assets/stroke.js';
import 'react';
import { classNames } from '../../../utils/functions/classNames/classNames.js';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '@dynamic-labs/multi-wallet';
import { getWalletListItemLabel } from '../../../shared/utils/functions/getWalletListItemLabel/getWalletListItemLabel.js';
import '../../../shared/consts/index.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '../../../utils/constants/colors.js';
import { pixelToRem } from '../../../utils/functions/pixelToRem/pixelToRem.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../context/ThemeContext/ThemeContext.js';
import { Icon } from '../../../components/Icon/Icon.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../config/ApiEndpoint.js';
import '../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import { useWalletItemActions } from '../../../utils/hooks/useWalletItemActions/useWalletItemActions.js';
import '../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../components/IconButton/IconButton.js';
import { ListTile } from '../../../components/ListTile/ListTile.js';
import { Badge } from '../../../components/Badge/Badge.js';

const WalletListItem = ({ usingMultiWallet, wallet, onResetSearchValue, tile = ({ leading, name, onClick, trailing }) => (jsx(ListTile, Object.assign({ leading: leading, trailing: trailing, onClick: onClick, className: 'wallet-list-item__tile' }, { children: name }))), }) => {
    const { handleWalletItemClick } = useWalletItemActions();
    const label = getWalletListItemLabel({
        isInstalledOnBrowser: wallet.isInstalledOnBrowser,
        usingMultiWallet,
        walletName: wallet.walletConnector.name,
    });
    const Tile = tile;
    const isComingSoon = label === 'Coming soon';
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isComingSoon) {
            return;
        }
        onResetSearchValue === null || onResetSearchValue === void 0 ? void 0 : onResetSearchValue('');
        yield handleWalletItemClick(wallet);
    });
    const leading = (jsx(WalletIcon, { walletName: wallet.name, style: { height: pixelToRem(28), width: pixelToRem(28) } }));
    const trailing = (jsxs("div", Object.assign({ className: 'wallet-list-item__trailing' }, { children: [label && (jsx("div", Object.assign({ className: classNames('trailing__child', {
                    trailing__label: !isComingSoon,
                }) }, { children: jsx(Badge, { dot: !isComingSoon, text: label, className: 'trailing__badge' }) }))), !isComingSoon && (jsx("div", Object.assign({ className: 'trailing__child trailing__arrow' }, { children: jsx(Icon, Object.assign({ color: 'text-tertiary', size: 'small' }, { children: jsx(SvgStroke, {}) })) })))] })));
    return (jsx(Tile, { leading: leading, trailing: trailing, name: getWalletBookWallet(wallet.name).name, onClick: handleClick }));
};

export { WalletListItem };
